// extracted by mini-css-extract-plugin
module.exports = {"required":"MaterialFormFields_required__D1SB6","removeIcon":"MaterialFormFields_removeIcon__CCUig","addBtn":"MaterialFormFields_addBtn__1pJ-i"};